module.exports = __webpack_public_path__ + "static/media/photon.2c036b0a.webp";